var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Packet from './Packet';
import { api } from '../../helpers/Api';
import { Eagers } from '../../helpers/Eagers';
import { action, observable } from 'mobx';
export default class PacketsStore {
    constructor() {
        this.data = [];
        this.loaded = false;
        this.read = (id) => {
            if (id) {
                return api.get(`packets/${id}?eager=${Eagers.packet}`);
            }
            return api.get(`packets?eager=${Eagers.packet}`)
                .then((value) => {
                // console.log('Stretches/Store - read() - value', value)
                return this.set(value);
            });
        };
        this.set = (values) => {
            this.data = values.map((item) => new Packet(item));
            this.loaded = true;
            return this.data;
        };
    }
    setData(data) {
        this.set(data);
    }
}
__decorate([
    observable
], PacketsStore.prototype, "data", void 0);
__decorate([
    observable
], PacketsStore.prototype, "loaded", void 0);
__decorate([
    action
], PacketsStore.prototype, "set", void 0);
__decorate([
    action
], PacketsStore.prototype, "setData", null);



//////////////////
// WEBPACK FOOTER
// ./src/modules/Packets/PacketsStore.ts
// module id = 569
// module chunks = 0